import Const from 'constants';

const defaultState = {
    component: '',
    open: false,
};

export default function (state = defaultState, action) {
    if (inArray(action.type, [Const.OPEN_MODAL, Const.CLOSE_MODAL])) {
        state = {...state, ...action.data};
    }

    return state;
}
